var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeriesFeriados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.333 25V58.3333M66.6666 25V58.3333M33.3333 91.6667H166.667M33.3333 58.3333C33.3333 53.9131 35.0892 49.6738 38.2148 46.5482C41.3404 43.4226 45.5796 41.6667 49.9999 41.6667H150C154.42 41.6667 158.659 43.4226 161.785 46.5482C164.911 49.6738 166.667 53.9131 166.667 58.3333V158.333C166.667 162.754 164.911 166.993 161.785 170.118C158.659 173.244 154.42 175 150 175H49.9999C45.5796 175 41.3404 173.244 38.2148 170.118C35.0892 166.993 33.3333 162.754 33.3333 158.333V58.3333ZM91.6666 133.333C91.6666 135.543 92.5446 137.663 94.1074 139.226C95.6702 140.789 97.7898 141.667 99.9999 141.667C102.21 141.667 104.33 140.789 105.892 139.226C107.455 137.663 108.333 135.543 108.333 133.333C108.333 131.123 107.455 129.004 105.892 127.441C104.33 125.878 102.21 125 99.9999 125C97.7898 125 95.6702 125.878 94.1074 127.441C92.5446 129.004 91.6666 131.123 91.6666 133.333Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeriesFeriados);
export default __webpack_public_path__ + "static/media/SeriesFeriados.9bc803a815daf8a07dbfd92b6e3bde9b.svg";
export { ForwardRef as ReactComponent };